import React from "react";
import "./toast.css";

const Toast = ({ status, text }) => {
  return <div className={`toast-wrapper ${status}`}>{text}</div>;
};

export default Toast;
